export * from "./user.ts";
export * from "./meeting.ts";
export * from "./interview.ts";
export * from "./release.ts";
export * from "./calendar.ts";
export * from "./api.ts";
export * from "./ws.ts";
export * from "./scenarios.ts";
export * from "./lang.ts";
export * from "./marketplace.ts";
export * from "./devtokens.ts";
export * from "./client-errors.ts";
export * from "./training.ts";

export type ISO8601 = string;
export type HexColor = string;
export type UUID = string;

/** Normalized slug / cache key for a company name. Shared by the API (Firestore
 * doc id for `companyProfiles`) and the web app (profile lookups). */
export function companySlug(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
